/**
 * @license
 * Copyright 2018-2021 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import styled from "@emotion/styled"

export const StyledWidgetLabel = styled.label(({ theme }) => ({
  fontSize: theme.fontSizes.smDefault,
  color: theme.colors.bodyText,
  marginBottom: theme.fontSizes.halfSmDefault,
}))

export const StyledWidgetLabelHelp = styled.div(() => ({
  position: "absolute",
  top: "1px",
  right: 0,
}))

export const StyledWidgetInstructions = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes.smDefault,
  color: theme.colors.fadedText60,
  margin: theme.spacing.none,
  textAlign: "right",
  position: "absolute",
  bottom: "0.4rem",
  right: "0.6rem",
}))

export const StyledWidgetLabelHelpInline = styled.label(() => ({
  marginLeft: "10px",
  position: "relative",
  top: "-1px",
}))
